import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

interface CustomTopToastProps {
  content: React.ReactNode;
  duration?: number;
  position?: 'top' | 'middle' | 'bottom';
  onClose?: () => void;
}

const CustomTopToast: React.FC<CustomTopToastProps> = ({
  content,
  duration = 2000,
  position = 'top',
  onClose
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!visible) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 pointer-events-none z-50 flex items-start justify-center">
      <div 
        className={`
          max-w-xs bg-black bg-opacity-80 text-white rounded-md px-4 py-2 shadow-lg
          pointer-events-auto transition-all duration-300 ease-in-out
          ${position === 'top' ? 'mt-16' : position === 'middle' ? 'mt-[40vh]' : 'mt-auto mb-16'}
        `}
      >
        {content}
      </div>
    </div>,
    document.body
  );
};

interface CustomTopToastApi {
  show: (props: CustomTopToastProps) => void;
}

const customTopToast: CustomTopToastApi = {
  show: (props) => {
    const div = document.createElement('div');
    document.body.appendChild(div);

    const onClose = () => {
      ReactDOM.unmountComponentAtNode(div);
      document.body.removeChild(div);
      props.onClose?.();
    };

    ReactDOM.render(
      <CustomTopToast {...props} onClose={onClose} />,
      div
    );
  }
};

export default customTopToast;